export enum LocalizationLanguage {
    none = 0,
    norwegian = 1,
    english = 2,
    swedish = 3,
    danish = 4,
    finnish = 5,
}
